import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const navLinks = [
        { href: "/", label: "Home" },
        { href: "/estoque", label: "Estoque" },
        { href: "/financiamento", label: "Financiamento" },
        { href: "/venda", label: "Venda" },
        { href: "/contato", label: "Contato" },
        { href: "/sobre", label: "Sobre" },
    ];

    return (
        <header
            className={`px-6 py-4 fixed w-full top-0 left-0 z-50 transition-colors duration-300 bg-white shadow flex items-center ${scrolled ? "scrolled" : ""}`}
        >
            <div className="flex items-center justify-between w-full">
                <Link to="/">
                    <img
                        src="/logo.png"
                        alt="Logo do Grupo Ibiza"
                        width={150}
                        height={50}
                    />
                </Link>

                <div className="md:hidden">
                    <button
                        onClick={() => setMenuOpen(!menuOpen)}
                        className="text-3xl text-gray-900 transition-colors duration-300"
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>
                </div>

                <nav className="hidden md:flex">
                    <ul className="flex items-center gap-6 font-semibold text-gray-900">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    className={`relative pb-1 transition-colors ${
                                        pathname === link.href
                                            ? "after:content-[''] after:absolute after:left-0 after:right-0 after:-bottom-0.5 after:h-1 after:bg-blue-600 after:rounded"
                                            : ""
                                    }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            {menuOpen && (
                <div className="absolute top-full left-0 w-full bg-white shadow-md md:hidden">
                    <ul className="flex flex-col items-start px-6 py-4 text-gray-900 font-semibold gap-4">
                        {navLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    onClick={() => setMenuOpen(false)}
                                    className={`block w-full py-2 border-b border-gray-100 ${
                                        pathname === link.href ? "text-blue-600" : ""
                                    }`}
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </header>
    );
}
